import { Button } from "../../atoms/Buttons";
import { StatusBadge } from "../../atoms/StatusBadge";
import * as S from "./mainContentItem.styles";
import { TransportationType } from "../../../interface/transportation";
import { formatPrice } from "../../../common/common.fn";
import { ReactComponent as IconLocation } from "../../../styles/assets/svg/icon-gps.svg";
import dayjs from "dayjs";
import {
  transportationTranslaterToNumber,
  transportationTranslaterToString,
} from "../../../lib/transportationTranslater";
import { Link } from "react-router-dom";

interface MainContentItemProps {
  transportations: TransportationType[];
  contentTit: string;
  isLoading: boolean;
  moveToMatchlist: () => void;
  moveToMatchListDetail: () => void;
  handleCancelRequest?: () => void;
}

export const MainContentsItem = ({
  transportations,
  isLoading,
  contentTit,
  moveToMatchlist,
  moveToMatchListDetail,
  handleCancelRequest,
}: MainContentItemProps) => {
  console.log("transportations", transportations);
  return (
    <S.MainContentsItem>
      {transportations.length === 0 && !isLoading && (
        <>
          {contentTit === "운송정보" && (
            <>
              <S.NodataItemBox>
                <p>현재 매칭된 배차 정보가 없습니다.</p>
              </S.NodataItemBox>
              <Link to="/matchlist">
                <S.MatchButtonBox>
                  <Button size="full" onClick={moveToMatchlist}>
                    운송 매칭하기
                  </Button>
                </S.MatchButtonBox>
              </Link>
            </>
          )}
          {contentTit === "배차정보" && (
            <S.NodataItemBox>
              <p>현재 매칭된 배차 정보가 없습니다.</p>
            </S.NodataItemBox>
          )}
        </>
      )}
      {transportations?.map((transportation: TransportationType) => (
        <S.DataItemBox>
          <S.DataHeadBox>
            <div className="driveNumber">
              <span>운송번호</span>
              {transportation?.order_number}
            </div>
          </S.DataHeadBox>

          <S.DataRouteBox>
            <S.DataRouteBoxHead>
              <S.DataRouteHeadTopBox>
                {/* 4/6 스텝 부분 */}
                <S.DataRouteStep>
                  {transportationTranslaterToNumber(
                    transportation?.status,
                    transportation?.transport_type
                  )}
                  / {transportation?.transport_type === 1 ? 6 : 4}
                </S.DataRouteStep>
                <S.DataRouteStepText>
                  {transportationTranslaterToString(
                    transportation?.status,
                    transportation?.transport_type
                  )}
                </S.DataRouteStepText>
              </S.DataRouteHeadTopBox>
              <S.DataRouteHeadBottomDateText>
                {dayjs(new Date()).format("YYYY-MM-DD HH:mm")} 기준
              </S.DataRouteHeadBottomDateText>
            </S.DataRouteBoxHead>

            <S.ProgressBarBox>
              <S.ProgressBar width={transportation?.order_state} />
            </S.ProgressBarBox>

            {(transportation?.order_state === "EN_ROUTE_TO_LOADING_POINT" ||
              transportation?.order_state === "EN_ROUTE_TO_WORK_POINT" ||
              transportation?.order_state ===
                "EN_ROUTE_TO_UNLOADING_POINT") && (
              <S.DataRouteBottomBox>
                <IconLocation />
                {transportation?.order_state ===
                  "EN_ROUTE_TO_LOADING_POINT" && (
                  <p>{transportation?.load_place_address}</p>
                )}
                {transportation?.order_state === "EN_ROUTE_TO_WORK_POINT" && (
                  <p>{transportation?.work_place_address}</p>
                )}
                {transportation?.order_state ===
                  "EN_ROUTE_TO_UNLOADING_POINT" && (
                  <p>{transportation?.unload_place_address}</p>
                )}
              </S.DataRouteBottomBox>
            )}
          </S.DataRouteBox>

          <S.DataListBox>
            <S.DataListBottomBox>
              <S.DataListText>요청사</S.DataListText>
              <S.DataListText className="contentText">
                {transportation?.company_name}
              </S.DataListText>
            </S.DataListBottomBox>
            <S.DataListBottomBox>
              <S.DataListText>예상요금</S.DataListText>
              <S.DataListText className="contentText">
                {formatPrice(transportation?.final_settlement_amount)}원
              </S.DataListText>
            </S.DataListBottomBox>
          </S.DataListBox>
          <S.MatchButtonBox>
            {transportation?.order_state === "TRANSPORTATION_CANCEL_REQUEST" ? (
              <StatusBadge status="canceling" />
            ) : (
              <>
                <Button
                  size="full"
                  color="transparent"
                  onClick={handleCancelRequest}
                >
                  취소 요청
                </Button>
                <Button size="full" onClick={moveToMatchListDetail}>
                  내 운송정보 보기
                </Button>
              </>
            )}
          </S.MatchButtonBox>
        </S.DataItemBox>
      ))}
    </S.MainContentsItem>
  );
};
